import type { BannerContent } from "./global-banner.types";

/**
 * Gets the appropriate banner content based on current UTC time
 * @param now - Current date (defaults to new Date() for easier testing)
 * @returns Banner content configuration or null if no active promotion
 */
export function getBannerContent(now: Date = new Date()): BannerContent | null {
  const utcTime = now.getTime();

  // Wednesday 26th November 2025 9am UTC - Friday 28th November 2025 9am UTC
  const blackFridayStart = Date.UTC(2025, 10, 26, 9, 0, 0); // Month is 0-indexed (10 = November)
  const blackFridayEnd = Date.UTC(2025, 10, 28, 9, 0, 0);

  // Friday 28th November 2025 9am UTC - Saturday 29th November 2025 12am UTC (midnight)
  const lastChanceBlackFridayStart = blackFridayEnd;
  const lastChanceBlackFridayEnd = Date.UTC(2025, 10, 29, 0, 0, 0);

  // Saturday 29th November 2025 12am UTC - Monday 1st December 2025 9am UTC
  const cyberMondayStart = lastChanceBlackFridayEnd;
  const cyberMondayEnd = Date.UTC(2025, 11, 1, 9, 0, 0); // Month is 0-indexed (11 = December)

  // Monday 1st December 2025 9am UTC - Monday 1st December 2025 11:59pm UTC (end of day)
  const lastChanceCyberMondayStart = cyberMondayEnd;
  const lastChanceCyberMondayEnd = Date.UTC(2025, 11, 1, 23, 59, 59);

  if (utcTime >= blackFridayStart && utcTime < blackFridayEnd) {
    return {
      title: "BLACK FRIDAY DEALS",
      subtitle: "MEMBERS EXTRA 20% OFF",
      text: "REGISTER OR LOGIN TO USE CODE",
      code: "BLACK20",
      colorScheme: "blackFriday",
    };
  }

  if (
    utcTime >= lastChanceBlackFridayStart &&
    utcTime < lastChanceBlackFridayEnd
  ) {
    return {
      title: "EXTRA 20% OFF EVERYTHING",
      subtitle: "LAST CHANCE ENDS MIDNIGHT",
      text: "REGISTER AND USE CODE",
      code: "BLACK20",
      colorScheme: "lastChanceBlackFriday",
    };
  }

  if (utcTime >= cyberMondayStart && utcTime < cyberMondayEnd) {
    return {
      title: "CYBER MONDAY DEALS",
      subtitle: "NEW CUSTOMERS EXTRA 20% OFF",
      text: "REGISTER AND USE CODE",
      code: "CYBER20",
      colorScheme: "cyberMonday",
    };
  }

  if (
    utcTime >= lastChanceCyberMondayStart &&
    utcTime <= lastChanceCyberMondayEnd
  ) {
    return {
      title: "CYBER MONDAY DEALS END MIDNIGHT",
      subtitle: "NEW CUSTOMERS EXTRA 20% OFF",
      text: "REGISTER AND USE CODE",
      code: "CYBER20",
      colorScheme: "cyberMonday",
    };
  }

  return null;
}
